import { BlogRepository } from '../../domain/repositories/blog.repository';
import { blogRepository } from '../repositories/blog.respository';

export const blogRepositoryInstance: BlogRepository = blogRepository();
